export default { keys: [
  'NO_PROPER_NAMES',
  'FAMILY_ALREADY_EXISTS',
  'FAMILY_FOUND_IN_INVENTORY',
  'FAMILY_NAME_PRESENT_IN_TRADEMARK_PROTECTION_LIST',
  'FAMILY_NAME_PRESENT_IN_FOUNDRY_NAME',
  'FONT_HAS_GLYPHS_WITH_INTERSECTING_CONTOURS',
  'FONT_HAS_GLYPHS_WITH_WRONG_CONTOUR_WINDING_DIRECTION',
  'FONT_HAS_GLYPHS_WITH_OVERLAPPING_CONTOURS',
  'MISSING_GLYPHS_FOR_MINIMUM_CHARACTERSET',
  'FILESIZE_TOO_LARGE',
  'FONT_MAY_HAVE_CLIPPING',
  'FONT_MAY_HAVE_CLIPPING',
  'GLYPH_SPACING_VERY_UNEVEN',
  'GLYPH_SPACING_VERY_UNEVEN',
  'FONT_IS_NOT_A_VALID_FONT',
  'FONT_IS_NOT_A_VALID_FONT',
  'NO_PROPER_NAMES',
  'NO_PROPER_NAMES',
  'NO_PROPER_NAMES',
  'NO_PROPER_NAMES',
  'FONT_HAS_NO_KERNING',
  'VARYING_VERTICAL_METRICS_BETWEEN_FONTS',
  'DOUBLE_STYLENAME',
  'DOUBLE_POSTSCRIPT_NAME',
  'DOUBLE_STYLE_UNIQUE_NAME',
  'DOUBLE_VERSION_NAME',
  'NO_POSTSCRIPT_NAME',
  'NO_VERSION_NAME',
  'STYLELINKING_CONFLICT',
  'STYLELINKING_CONFLICT',
  'STYLELINKING_CONFLICT',
  'STYLELINKING_CONFLICT',
  'MULTIPLE_FAMILYNAMES',
  'FONT_HAS_CRITICAL_ERRORS',
  'MULTIPLE_FORMATS',
  'MULTIPLE_FLAVOURS',
  'UNSUPPORTED_FORMAT',
  'GLYPH_SPACING_VERY_UNEVEN_O',
  'GLYPH_SPACING_VERY_UNEVEN_H',
  'VERSIONTEXT_NOT_SET',
  'FULLNAME_NOT_SET',
  'NAME_NOT_SET',
  'DUPLICATE_NAME_ENTRY',
  'MONGO_SPACE_EXCEEDED',
  'COPYRIGHT_INFORMATION_WARN',
  'COPYRIGHT_INFORMATION_ERROR'
] }
